import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal, Tooltip, Steps, Popover, Tag} from 'antd'
import { QuestionCircleFilled, CheckCircleOutlined, CloseCircleOutlined, StopOutlined, ClockCircleOutlined, CheckOutlined, CloseOutlined, SendOutlined, EyeOutlined, DeleteOutlined, CheckCircleFilled , CloseCircleFilled, MinusCircleFilled, ClockCircleFilled  } from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import RejectModal from './RejectModal'
import history from '../../../routes/history'
import moment from 'moment';
import * as AppUrl from '../../../constants/appUrl'
const storage = window.localStorage
const {confirm} = Modal
const { Step } = Steps;

@inject('marketingSmsManagementStore', 'accountStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    taskId: '',
    groupId: ''
  }

  componentDidMount() {
  }
  handleDetails = (record) => {
    const {type} = this.props
    history.push(`/smsManagementDetails?${record?.taskGroupId}&${record?.isHistory}`, {record,type})
  }
  handleAgree = (record) => {
    const {marketingSmsManagementStore, type, t} = this.props
    confirm({
      title: t(`general.agreeData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.agreeToData`),
      okText: t(`general.agree`),
      cancelText: t(`general.cancel`),
      className: "agree",
      onOk() {
        const params = {
          "approveResult": '3',
          "groupId": record?.groupId,
          "taskId": record?.id,
        }
        marketingSmsManagementStore.onAgreeAction(params)
      },
      onCancel() {
      },
    })
    return false
  }
  handleReject = (record) => {
    this.setState({
      "addModalVisible": true,
      "taskId": record?.id,
      "groupId": record?.groupId,
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handlePageChange = (page, pageSize) => {
    const {marketingSmsManagementStore, type} = this.props
    marketingSmsManagementStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  handleDel = (record) => {
    const {marketingSmsManagementStore,t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        marketingSmsManagementStore.onDeleteJobAction(record?.id)
      },
      onCancel() {
      },
    })
    return false
  }
  handleResend = (record) => {
    const {marketingSmsManagementStore,t} = this.props
    confirm({
      title: t(`general.resendData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToResend`),
      okText: t(`general.resend`),
      cancelText: t(`general.cancel`),
      onOk() {
        marketingSmsManagementStore.onReSendAction({
          "approveResult": null,
          "groupId": record?.groupId,
          "refuseReason": null,
          "taskId": record?.id
        })
      },
      onCancel() {
      },
    })
    return false
  }
  render() {
    const {marketingSmsManagementStore, t} = this.props
    const {pageNo, pageSize, itemCount, jobList, statusList} = marketingSmsManagementStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    const customDot = (dot, { status, index }, stepData) => { 
      const { approver, approveTime, approveStatus, refuseReason } = stepData;
      return (
      <Popover
        content={<>
          <div>审批人： {approver} </div>
          <div>审批时间： {approveTime} </div>
          <div>审批状态： {statusList?.find(a=> a?.code === approveStatus)?.name}</div>
          {approveStatus==='4' ? <div>原因： {refuseReason} </div> : null}
        </>}
      >
        {!approver ? <MinusCircleFilled style={{color: 'rgba(0, 0, 0, 0.25)'}} /> : approveStatus==='3' ? <CheckCircleFilled style={{color: 'green'}} /> : approveStatus==='4' ? <CloseCircleFilled /> : approveStatus==='1' ? <ClockCircleFilled style={{color: 'rgba(0, 0, 0, 0.25)'}} /> : <MinusCircleFilled />}
      </Popover>
    )};
    const hasScheduleTime = (array) => {
      // 使用some()方法遍历数组，找到第一个符合条件的元素即返回true
      return array.some(item => item && item.scheduleTime);
    };
    return (
      <>
        <Table className="searchResult" dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} scroll={{x: '110%'}} bordered>
          <Table.Column width={100} title={t(`marketingManagement.marketingGroup`)} dataIndex="groupName" key="groupName" ellipsis={true} />
          <Table.Column width={180} title={t(`marketingManagement.taskName`)} dataIndex="taskName" key="taskName" ellipsis={true}
            // render={(text, record) => 
            //   <>{text}{record.btnStatus?.canResend==='0' ? 
            //   <Tooltip title='存在短信未发送成功！'><ExclamationCircleFilled style={{color: 'red', paddingLeft: 6}} /></Tooltip>
            //   : null} </>
            // } 
          />
          <Table.Column width={hasScheduleTime(toJS(jobList)) ? 200 : 120} title={t(`marketingManagement.status`)} dataIndex="status" key="status" ellipsis={true} render={(text, record) =>
          <>
            <Tag  color={text==='3' || text==='00' ? "success" : text==='15' || text==='5' ? "error" : text==='6' ? null : "cyan" }>
              {text==='3' || text==='00' ? <CheckCircleOutlined /> : text==='15' || text==='5' ? <CloseCircleOutlined /> : text==='6' ? <StopOutlined /> : <ClockCircleOutlined />}
              {' '}
              {statusList?.find(a=> a?.code===text)?.name}
            </Tag><br />
            {record?.scheduleTime  ? moment() < moment(record?.scheduleTime) ? <Tag color="blue" style={{height: 'auto'}}>定时发送时间：<br />{record.scheduleTime}</Tag> : null : null}
            </>
          } />
          <Table.Column width={100} title={t(`marketingManagement.approvalStatus`)} dataIndex="approveLogList" key="approveLogList" ellipsis={true} render={(text, record) => (
            <Steps style={{width: '100%'}} progressDot={(dot, { status, index }) =>
              customDot(dot, { status, index }, text[index])
            }>
              {text.map((a,i)=> {return <Step key={i} status={
                a?.approveStatus==='6' ? 'wait' : a?.approveStatus==='1' ? 'process' : a?.approveStatus==='3' ? 'Finished' : a?.approveStatus==='4' ? 'error'
              : null} />})}
            </Steps>
          )} />
          <Table.Column width={270} title='发送详情' dataIndex="numberCount" key="numberCount" ellipsis={true} render={(text, record) =>
            <div>
              <div style={{display: 'flex', justifyContent: 'space-between', color: '#40a9ff'}}>
                <div>发送数量: {record.numberCount}</div>
                <div>发送中: {record.sendingSmsNumber}</div>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', color: '#73d13d'}}>
                <div>发送成功: {record.successSmsNumber}</div>
                <div>成功率: {record.successRate}</div>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', color: '#ff4d4f'}}>
                <div>发送失败: {record.failedSmsNumber}</div>
                <div>失败率: {record.failedRate}</div>
              </div>
            </div>
          }/>
          <Table.Column width={100} title={(<>{t(`marketingManagement.amount`)} <Tooltip title={t('marketingManagement.amountTips')}>
            <QuestionCircleFilled />
          </Tooltip></>)}  dataIndex="smsNumber" key="smsNumber" ellipsis={true}/>
          <Table.Column width={400} title={t(`marketingManagement.smsContent`)} dataIndex="content" key="content"/>
          {/*<Table.Column width={130} title={(<>{t(`marketingManagement.sendSuccessfulSum`)} <Tooltip title={t('marketingManagement.sendSuccessfulSumTips')}>*/}
          {/*  <QuestionCircleFilled />*/}
          {/*</Tooltip></>)} dataIndex="successSmsNumber" key="successSmsNumber" ellipsis={true}/>*/}
          <Table.Column width={140} title={t(`marketingManagement.exhibitionSession`)} dataIndex="expoResume" key="expoResume" ellipsis={true}/>
          <Table.Column width={140} title={t(`marketingManagement.signature`)} dataIndex="signName" key="signName" ellipsis={true} render={(text, record) =>
            `【${text}】`
          } />
          {/* <Table.Column title={t(`marketingManagement.receivedSuccessfulSum`)} dataIndex="intervalSecond" key="intervalSecond" ellipsis={true}/> */}
          {/* <Table.Column title={t(`marketingManagement.approvalStatus`)} dataIndex="approveStatus" key="approveStatus" ellipsis={true} render={(text, record) =>
            statusList?.find(a=> a?.code===text)?.name
          } /> */}
          <Table.Column width={220} title='时间' dataIndex="submitTime" key="submitTime" ellipsis={true}
                        render={(text, record) =>
                          <div>
                            <div>提交时间: {record.submitTime}</div>
                            <div>发送时间: {record.sendTime}</div>
                          </div>
                        }/>
          {/*<Table.Column width={180} title={t(`marketingManagement.sendTime`)} dataIndex="sendTime" key="sendTime" ellipsis={true}/>*/}
          <Table.Column width={200} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
            { record.btnStatus?.canApprove==='0' ? <>
              <Button type="link" style={{color: 'green'}} onClick={() => this.handleAgree(record)} icon={<CheckOutlined />} title={t(`general.agree`)}/>
              <Button type="link" style={{color: 'red'}} onClick={() => this.handleReject(record)} icon={<CloseOutlined />} title={t(`general.reject`)}/>
              </> : null }
            { record.btnStatus?.canDelete==='0' ? <>
                <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
              </> : null }
            { record.btnStatus?.canResend==='0' ? <>
              <Button type="link" onClick={() => this.handleResend(record)} icon={<SendOutlined />} title={t(`general.resend`)}/>
              </> : null }
            { record.btnStatus?.canDetail==='0' ? <>
              <Button type="link" onClick={() => this.handleDetails(record)} icon={<EyeOutlined />} title={t(`general.details`)}/>
              </> : null }
            </>
          )} />
        </Table>
        {this.state.addModalVisible ? <RejectModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          taskId={this.state.taskId}
          groupId={this.state.groupId}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
